export default __webpack_public_path__ + "static/media/Group 1171276208 (2).e8d0e99a.svg";